__webpack_require__.p = "https://app.talabat.boolanga.com/";